import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const API = "https://admin.bridge365.in/wp-json/wc/v3";
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";

function getAncestorIds(categories, categoryId) {
  const ids = [];
  const seen = new Set();
  let current = categories.find((cat) => cat.id === Number(categoryId));

  while (current && !seen.has(current.id)) {
    seen.add(current.id);
    ids.push(current.id);
    current = categories.find((cat) => cat.id === current.parent);
  }

  return ids;
}

function useActiveMenu(categories = []) {
  const location = useLocation();
  const [productCategoryIds, setProductCategoryIds] = useState([]);

  const categoryMatch = location.pathname.match(/^\/category\/(\d+)/);
  const productMatch = location.pathname.match(/^\/product\/(\d+)/);
  const currentCategoryId = categoryMatch ? Number(categoryMatch[1]) : null;
  const productId = productMatch ? productMatch[1] : null;

  useEffect(() => {
    if (!productId) {
      setProductCategoryIds([]);
      return;
    }

    fetch(`${API}/products/${productId}?consumer_key=${CK}&consumer_secret=${CS}`)
      .then((res) => res.json())
      .then((data) =>
        setProductCategoryIds((data.categories || []).map((category) => category.id))
      )
      .catch(() => setProductCategoryIds([]));
  }, [productId]);

  const activeCategoryIds = [
    ...(currentCategoryId ? [currentCategoryId] : []),
    ...productCategoryIds,
  ];

  const isHomeActive = location.pathname === "/" || location.pathname === "/home";

  const isCategoryActive = (categoryId) =>
    activeCategoryIds.some((id) => getAncestorIds(categories, id).includes(categoryId));

  const isExactCategoryActive = (categoryId) =>
    activeCategoryIds.includes(Number(categoryId));

  return {
    isHomeActive,
    isCategoryActive,
    isExactCategoryActive,
  };
}

export default useActiveMenu;
